const Main = () =>
    import ('@/views/main');
const storageSysSwitch = () =>
    import ('@/views/new-storage/storage-sys-switch');
const newStorageIndex = () =>
    import ('@/views/new-storage/storage-manage-index');
const storageDetail = () =>
    import ('@/views/new-storage/storage-detail');
const materielIntoWarehouse = () =>
    import ('@/views/new-storage/materiel-into-warehouse');
const materielAdd = () =>
    import ('@/views/new-storage/materiel-add');
const materielEdit = () =>
    import ('@/views/new-storage/materiel-add');
const newStorageSave = () =>
    import ('@/views/new-storage/storage-save');
const newBatchStorageSave = () =>
    import ('@/views/new-storage/batch-storage-save');
const materielManage = () =>
    import ('@/views/new-storage/materiel-manage');
const materielDetail = () =>
    import ('@/views/new-storage/materiel-detail');
const materielImport = () =>
    import ('@/views/new-storage/materiel-import');
const materielOuttoWarehouse = () =>
    import ('@/views/new-storage/materiel-outto-warehouse');
const materielOuttoWarehouseApply = () =>
    import ('@/views/new-storage/materiel-outto-warehouse-apply');
const materielInventoryCheckIndex = () =>
    import ('@/views/new-storage/materiel-inventory-check-index');
const materielInventoryCheck = () =>
    import ('@/views/new-storage/materiel-inventory-check');
const materielInventoryCheckDetail = () =>
    import ('@/views/new-storage/materiel-inventory-check-detail');
const materielDeleteIndex = () =>
    import ('@/views/new-storage/materiel-delete-index');
const materielDeleteApply = () =>
    import ('@/views/new-storage/materiel-delete-apply');
const allocationManageIndex = () =>
    import ('@/views/new-storage/allocation-manage-index');
const materielAllocationApply = () =>
    import ('@/views/new-storage/materiel-allocation-apply');
const materielRemind = () =>
    import ('@/views/new-storage/materiel-remind');
const materielQuoteManage = () =>
    import ('@/views/new-storage/materiel-quote-manage');
export default [{
    path: '/newStorage',
    name: 'newStorage',
    redirect: {
        name: 'storageSysSwitch'
    },
    component: Main,
    meta: {
        hide: false,
        name: '新仓储管理',
        unfold: true,
		iconType: '9'
    },
    children: [
        {
            path: 'storageSysSwitch',
            name: 'storageSysSwitch',
            component: storageSysSwitch,
            meta: {
                name: '仓储系统切换',
            }
        },
        {
            path: 'newStorageIndex',
            name: 'newStorageIndex',
            component: newStorageIndex,
            meta: {
                name: '仓库管理',
            },
            children: [{
                path: 'newStorageSave/:id',
                name: 'newStorageSave',
                component: newStorageSave,
                meta: {
                    name: '仓库仓储'
                },
            },
            {
                path: 'newBatchStorageSave/:warehouseId',
                name: 'newBatchStorageSave',
                component: newBatchStorageSave,
                meta: {
                    name: '批量库存增加',
                    hasBack: true
                },
            },
            {
                path: 'storageDetail/:id',
                name: 'storageDetail',
                component: storageDetail,
                meta: {
                    name: '仓库详情',
                    hasBack: true
                },
            }]
        },
        {
            path: 'materielQuoteManage',
            name: 'materielQuoteManage',
            component: materielQuoteManage,
            meta: {
                name: '物料管理',
            },
            children: [{
                    path: 'materielRemind',
                    name: 'materielRemind',
                    component: materielRemind,
                    meta: {
                        name: '批量报价',
                        hasBack: true
                    },
                },
                {
                    path: 'materielDetail/:id/:sysType',
                    name: 'materielQuoteDetail',
                    component: materielDetail,
                    meta: {
                        name: '物料详情',
                        hasBack: true
                    },
                },
            ],
        },
        {
            path: 'materielManage',
            name: 'materielManage',
            component: materielManage,
            meta: {
                name: '库存管理',
            },
            children: [{
                    path: 'materielIntoWarehouse',
                    name: 'materielIntoWarehouse',
                    component: materielIntoWarehouse,
                    meta: {
                        name: '商品入库'
                    },
                },
                {
                    path: 'materielAdd',
                    name: 'materielAdd',
                    component: materielAdd,
                    meta: {
                        name: '商品入库',
                        hasBack: true
                    },
                },
                {
                    path: 'materielEdit/:id',
                    name: 'materielEdit',
                    component: materielEdit,
                    meta: {
                        name: '商品编辑'
                    },
                },
                {
                    path: 'materielDetail/:id/:sysType',
                    name: 'materielDetail',
                    component: materielDetail,
                    meta: {
                        name: '商品详情',
                        hasBack: true
                    },
                },
                {
                    path: 'materielGoodsDetail/:id',
                    name: 'materielGoodsDetail',
                    component: materielDetail,
                    meta: {
                        name: '商品详情',
                        hasBack: true
                    },
                },
                {
                    path: 'materielImport',
                    name: 'materielImport',
                    component: materielImport,
                    meta: {
                        name: '批量商品导入',
                        hasBack: true
                    },
                },
                {
                    path: 'materielOuttoWarehouse',
                    name: 'materielOuttoWarehouse',
                    component: materielOuttoWarehouse,
                    meta: {
                        name: '商品出库'
                    },
                },
                {
                    path: 'materielOuttoWarehouseApply',
                    name: 'materielOuttoWarehouseApply',
                    component: materielOuttoWarehouseApply,
                    meta: {
                        name: '商品出库申请',
                        hasBack: true
                    },
                },
                {
                    path: 'materielInventoryCheckIndex',
                    name: 'materielInventoryCheckIndex',
                    component: materielInventoryCheckIndex,
                    meta: {
                        name: '库存盘点'
                    },
                },
                {
                    path: 'materielInventoryCheck',
                    name: 'materielInventoryCheck',
                    component: materielInventoryCheck,
                    meta: {
                        name: '库存盘点',
                        hasBack: true
                    },
                },
                {
                    path: 'materielInventoryCheckDetail/:id',
                    name: 'materielInventoryCheckDetail',
                    component: materielInventoryCheckDetail,
                    meta: {
                        name: '库存盘点详情',
                        hasBack: true
                    },
                },
                {
                    path: 'materielDeleteIndex',
                    name: 'materielDeleteIndex',
                    component: materielDeleteIndex,
                    meta: {
                        name: '商品删除'
                    },
                },
                {
                    path: 'materielDeleteApply',
                    name: 'materielDeleteApply',
                    component: materielDeleteApply,
                    meta: {
                        name: '商品删除',
                        hasBack: true
                    },
                },
            ],
        },
        // {
        //     path: 'allocationManageIndex',
        //     name: 'allocationManageIndex',
        //     component: allocationManageIndex,
        //     meta: {
        //         name: '调拨管理',
        //     },
        //     children: [{
        //         path: 'materielAllocationApply/:dispatchType',
        //         name: 'materielAllocationApply',
        //         component: materielAllocationApply,
        //         meta: {
        //             name: '商品调拨',
        //             hasBack: true
        //         },
        //     }]
        // },
    ]
}]